<template>
  <div>
    <div v-if="!connected">
      <connection v-on:connected="connectedUser"></connection>
    </div>

    <div v-else>
      <img class="logo" src="../../assets/img/logoColombbus.png">
      <div id="navigation">
        <div
          @click="current = 'users'"
          :class="current == 'users' ? 'active':''"
        >gestion des utilisateur</div>
        <div
          @click="current = 'rapports'"
          :class="current == 'rapports' ? 'active':''"
        >gestion des rapports</div>
        <div
          @click="current = 'etablisment'"
          :class="current == 'etablisment' ? 'active':''"
        >gestion des établisments</div>
      </div>
      <div v-if="current == 'users'">
        <user-manager></user-manager>
      </div>
      <div v-if="current == 'rapports'">
        <reports></reports>
      </div>
      <div v-if="current == 'etablisment'">
        <establishment-manager></establishment-manager>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'

import Connection from '@/components/admin/Connection'
import UserManager from '@/components/admin/UserManager'
import Reports from '@/components/admin/Reports'
import EstablishmentManager from '@/components/admin/EstablishmentManager'
// let BACK_END_PATH = process.env.VUE_APP_BACK_END_PATH

export default {
  data() {
    return {
      connected: false,
      current: 'users',
    }
  },
  methods: {
    connectedUser() {
      this.connected = true
    },
  },
  components: {
    Connection,
    UserManager,
    Reports,
    EstablishmentManager,
  },
}
</script>

<style>
.logo{
  border-radius: 10px;
  text-align: center;
}
#navigation {
  display: flex;
  justify-content: space-around;
  color: white;
  padding: 15px;
}
#navigation div {
  cursor: pointer;
}
#navigation .active {
  color: deepskyblue;
}
.error {
  color: red;
}
.success {
  color: green;
}
.monospaceFont {
  font-family: monospace;
}
</style>
